<template>
    <div class="team-page">
        <el-alert class="team-tip" title="您可以在此查看关于团队设定的相关信息" type="success" :closable="false" />

        <el-tabs v-model="this.activeTab" class="team-tabs">
            <!-- 团队列表 -->
            <el-tab-pane label="团队列表" name="all">
                <el-card class="panel-card" shadow="never">
                    <template #header>
                        <div class="panel-card__head">
                            <span class="panel-card__title">全部团队</span>
                            <span class="count-pill">共 {{ this.teams.all.length }} 个</span>
                        </div>
                    </template>
                    <el-table class="team-table" :data="this.teams.all" stripe style="width: 100%">
                        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                        <el-table-column prop="ownerUser.realName" label="录入人" width="110"></el-table-column>
                        <el-table-column prop="memberCount" label="团队人数" width="100" align="center"></el-table-column>
                        <el-table-column label="加入状态" width="100">
                            <template #default="scope_myJoinStatus">
                                <el-tag v-if="scope_myJoinStatus.row.myJoinStatus == 'y'" type="success" size="small" effect="plain">已加入</el-tag>
                                <el-tag v-else type="info" size="small" effect="plain">未加入</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="230">
                            <template #default="scopeOp">
                                <el-link class="op-link" type="primary" @click="queryMembers(scopeOp.row.id)">查看成员</el-link>
                                <el-link v-if="scopeOp.row.myJoinStatus == 'n'" class="op-link" type="warning" @click="joinTeam(scopeOp.row.id, 'autoJoinEmailSuffix', '')">自动加入</el-link>
                                <el-link v-if="scopeOp.row.myJoinStatus == 'n'" class="op-link" type="success" @click="openJoinTeam(scopeOp.row.id)">密码加入</el-link>
                                <el-link v-if="scopeOp.row.myJoinStatus == 'y'" class="op-link" type="success" @click="openInviteUser(scopeOp.row.id)">邀请成员</el-link>
                                <el-link v-if="scopeOp.row.myJoinStatus == 'y'" class="op-link" type="danger" @click="quitTeam(scopeOp.row.id, true)">退出团队</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-tab-pane>

            <!-- 我的团队（仅管理员可见） -->
            <el-tab-pane label="我的团队" name="owner" v-if="this.user.roles.includes('admin')">
                <el-card class="panel-card" shadow="never">
                    <template #header>
                        <div class="panel-card__head">
                            <span class="panel-card__title">我创建的团队</span>
                            <el-button type="primary" class="team-create-btn" @click="openCreateTeam">
                                <el-icon><Plus /></el-icon>
                                <span>创建团队</span>
                            </el-button>
                        </div>
                    </template>
                    <el-table class="team-table" :data="this.teams.owner" stripe style="width: 100%">
                        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                        <el-table-column prop="ownerUser.realName" label="录入人" width="110"></el-table-column>
                        <el-table-column prop="memberCount" label="团队人数" width="100" align="center"></el-table-column>
                        <el-table-column label="管理" width="200">
                            <template #default="scopeOp">
                                <el-link class="op-link" type="primary" @click="queryMembers(scopeOp.row.id)">查看成员</el-link>
                                <el-link class="op-link" type="warning" @click="openEditTeam(scopeOp.row.id, true)">编辑信息</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-tab-pane>
        </el-tabs>
    </div>

    <!-- Form 创建团队 -->
    <el-dialog class="team-dialog" :title="this.teamForm.mode == 'create' ? '创建团队' : '编辑团队'" v-model="this.teamForm.dialog" width="min(520px, 92vw)">
        <el-form :model="this.teamForm.prop" :label-width="formLabelWidth">
            <el-form-item label="名称">
                <el-input v-model="this.teamForm.prop.name" autocomplete="off" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="this.teamForm.prop.description" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="加入邮箱后缀">
                <el-input v-model="this.teamForm.prop.joinRule.autoJoinEmailSuffix" placeholder="example.com" autocomplete="off" maxlength="40">
                    <template #prepend>@</template>
                </el-input>
            </el-form-item>
            <el-form-item label="加入密码">
                <el-input v-model="this.teamForm.prop.joinRule.userJoinPassword" placeholder="请输入密码" autocomplete="off" maxlength="40"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="team-dialog__foot">
                <el-button @click="this.teamForm.dialog = false">取 消</el-button>
                <el-button type="primary" @click="saveTeam()">保 存</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- Form 密码加入到团队 -->
    <el-dialog class="team-dialog" v-model="this.joinTeamForm.dialog" title="使用密码加入团队" width="min(480px, 92vw)">
        <el-form :model="this.joinTeamForm.prop" :label-width="formLabelWidth">
            <el-form-item label="请输入密码">
                <el-input v-model="this.joinTeamForm.prop.joinPassword" autocomplete="off" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="team-dialog__foot">
                <el-button @click="this.joinTeamForm.dialog = false">取 消</el-button>
                <el-button type="primary" @click="joinTeam(this.joinTeamForm.prop.teamId, 'userJoinPassword', '')">加 入</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- Form 邀请到团队 -->
    <el-dialog class="team-dialog" v-model="this.inviteUserForm.dialog" title="邀请成员加入团队" width="min(520px, 92vw)">
        <el-form :model="this.inviteUserForm.prop" :label-width="formLabelWidth">
            <el-form-item label="成员邮箱">
                <el-input v-model="this.inviteUserForm.prop.email" autocomplete="off" type="textarea" :rows="6" placeholder="多个邮箱请用换行分隔" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="team-dialog__foot">
                <el-button @click="this.inviteUserForm.dialog = false">取 消</el-button>
                <el-button type="primary" @click="inviteUser()">邀 请</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 查看成员列表 -->
    <el-dialog class="team-dialog" v-model="this.memberListForm.dialog" title="成员列表" width="min(680px, 92vw)">
        <el-table class="team-table" :data="this.memberListForm.list" :default-sort="{ prop: 'createTime', order: 'descending' }" height="400" border stripe>
            <el-table-column type="index" label="序号" width="70" align="center" />
            <el-table-column prop="createTime" label="加入时间" sortable />
            <el-table-column prop="userInfo.realName" label="姓名" width="120" />
            <el-table-column prop="userInfo.email" label="邮箱" />
        </el-table>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
export default {
    data() {
        return {
            user: { roles: [] },
            teams: {
                all: [],
                owner: []
            },
            activeTab: 'all',
            formLabelWidth: '110px',
            teamForm: {
                mode: 'create',
                dialog: false,
                prop: {
                    id: '',
                    name: '',
                    description: '',
                    joinRule: { autoJoinEmailSuffix: '', userJoinPassword: '' }
                }
            },
            joinTeamForm: {
                dialog: false,
                prop: { joinPassword: '' }
            },
            inviteUserForm: {
                dialog: false,
                prop: { email: '' }
            },
            memberListForm: {
                dialog: false,
                list: []
            }
        };
    },
    mounted() {
        this.user.roles = this.$store.state.user.roles;
        this.showAllTeams();
        this.showOwnerTeams();
    },
    components: {},
    methods: {
        openCreateTeam() {
            // 清空表单数据
            this.teamForm.prop.name = '';
            this.teamForm.prop.description = '';
            this.teamForm.prop.joinRule.autoJoinEmailSuffix = '';
            this.teamForm.prop.joinRule.userJoinPassword = '';
            this.teamForm.mode = 'create';
            this.teamForm.dialog = true;
        },
        openEditTeam(teamId) {
            return request({
                url: '/team/get',
                method: 'post',
                data: { token: this.$store.state.user.token, id: teamId }
            }).then(res => {
                if (res.code == 0 && res.meta.team) {
                    this.teamForm.prop = res.meta.team;
                    if (this.teamForm.prop.joinRule == undefined) this.teamForm.prop.joinRule = {};
                    if (this.teamForm.prop.joinRule.autoJoinEmailSuffix == undefined) this.teamForm.prop.joinRule.autoJoinEmailSuffix = '';
                    if (this.teamForm.prop.joinRule.userJoinPassword == undefined) this.teamForm.prop.joinRule.userJoinPassword = '';
                    this.teamForm.mode = 'edit';
                    this.teamForm.dialog = true;
                }
            });
        },
        saveTeam() {
            if (this.teamForm.mode == 'create') {
                return request({
                    url: '/team/create',
                    method: 'post',
                    data: {
                        name: this.teamForm.prop.name,
                        description: this.teamForm.prop.description,
                        joinRule: this.teamForm.prop.joinRule
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.teamForm.dialog = false;
                        this.showOwnerTeams();
                    }
                });
            }
            if (this.teamForm.mode == 'edit') {
                return request({
                    url: '/team/edit',
                    method: 'post',
                    data: {
                        id: this.teamForm.prop.id,
                        name: this.teamForm.prop.name,
                        description: this.teamForm.prop.description,
                        joinRule: this.teamForm.prop.joinRule
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.teamForm.dialog = false;
                        this.showOwnerTeams();
                    }
                });
            }
        },
        showOwnerTeams() {
            return request({
                url: '/team/getOwnerTeams',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.teams.owner = res.data;
                }
            });
        },
        showAllTeams() {
            return request({
                url: '/team/getAllTeams',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.teams.all = res.data;
                }
            });
        },
        openJoinTeam(teamId) {
            this.joinTeamForm.prop.teamId = teamId;
            this.joinTeamForm.prop.joinPassword = '';
            this.joinTeamForm.dialog = true;
        },
        joinTeam(teamId, type, value) {
            switch (type) {
                case 'userJoinPassword':
                    return request({
                        url: '/teamMember/create',
                        method: 'post',
                        data: { teamId: teamId, type: type, value: this.joinTeamForm.prop.joinPassword }
                    }).then(res => {
                        if (res.code == 0) {
                            console.log(res);
                            this.showAllTeams();
                            this.joinTeamForm.dialog = false;
                        }
                    });
                case 'autoJoinEmailSuffix':
                    return request({
                        url: '/teamMember/create',
                        method: 'post',
                        data: { teamId: teamId, type: type, value: '' }
                    }).then(res => {
                        if (res.code == 0) {
                            console.log(res);
                            this.showAllTeams();
                        }
                    });
            }
        },
        quitTeam(teamId) {
            return request({
                url: '/teamMember/delete',
                method: 'post',
                data: { teamId: teamId }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.showAllTeams();
                }
            });
        },
        queryMembers(teamId) {
            this.memberListForm.list = [];
            return request({
                url: '/teamMember/list',
                method: 'post',
                data: { teamId: teamId }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.memberListForm.list = res.data;
                    this.memberListForm.dialog = true;
                }
            });
        },
        openInviteUser(teamId) {
            this.inviteUserForm.prop.teamId = teamId;
            this.inviteUserForm.prop.email = '';
            this.inviteUserForm.dialog = true;
        },
        inviteUser() {
            return request({
                url: '/teamMember/invite',
                method: 'post',
                data: { teamId: this.inviteUserForm.prop.teamId, email: this.inviteUserForm.prop.email }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.showAllTeams();
                    this.inviteUserForm.dialog = false;
                }
            });
        }
    }
};
</script>

<style scoped>
/* ===================== 团队信息 ===================== */
.team-page {
    --team-text: #1f2d3d;
    --team-sub: #5b6a80;
    --team-muted: #8a94a6;
    --team-line: #eef0f4;

    /* 局部覆盖主色，避免影响其它页面 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    color: var(--team-text);
}

/* ---------- 顶部说明 ---------- */
.team-page .team-tip {
    margin-bottom: 14px;
    border-radius: 10px;
}

/* ---------- 视图切换 ---------- */
.team-page :deep(.team-tabs .el-tabs__header) {
    margin: 0 0 14px;
}
.team-page :deep(.team-tabs .el-tabs__nav-wrap::after) {
    height: 0;
}
.team-page :deep(.team-tabs .el-tabs__active-bar) {
    display: none;
}
.team-page :deep(.team-tabs .el-tabs__item) {
    height: 34px;
    margin-right: 4px;
    padding: 0 16px;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 500;
    line-height: 34px;
    color: var(--team-sub);
    transition: background-color 0.2s, color 0.2s;
}
.team-page :deep(.team-tabs .el-tabs__item:hover) {
    color: var(--team-text);
    background-color: #f2f5fa;
}
/* 选中态：浅蓝底 + 主色字（写在 hover 之后，保证选中项 hover 不回退） */
.team-page :deep(.team-tabs .el-tabs__item.is-active) {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
}

/* ---------- 面板卡 ---------- */
.team-page .panel-card {
    margin: 0;
    border: 1px solid var(--team-line);
    border-radius: 12px;
}
.team-page .panel-card :deep(.el-card__header) {
    padding: 14px 18px;
    border-bottom: 1px solid var(--team-line);
}
.team-page .panel-card :deep(.el-card__body) {
    padding: 16px 18px;
}
.panel-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.panel-card__title {
    position: relative;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 600;
}
.panel-card__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 14px;
    margin-top: -7px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}
.count-pill {
    flex: none;
    padding: 2px 8px;
    border-radius: 999px;
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
    font-size: 12px;
    font-weight: 500;
}

/* ---------- 主按钮 ---------- */
.team-page .team-create-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    box-shadow: 0 8px 18px -10px rgba(47, 111, 237, 0.65);
}
.team-page .team-create-btn .el-icon {
    margin-right: 6px;
    font-size: 15px;
}

/* ---------- 表格 ---------- */
.team-page :deep(.team-table) {
    --el-table-header-bg-color: #f7f9fc;
    font-size: 13px;
}
.team-page :deep(.team-table th.el-table__cell) {
    color: var(--team-muted);
    font-weight: 600;
}
.team-page :deep(.team-table .el-table__cell) {
    padding: 8px 0;
}

/* ---------- 行内操作 ---------- */
.op-link {
    margin-right: 12px;
    font-size: 13px;
}
.op-link:last-child {
    margin-right: 0;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    .panel-card__head {
        flex-wrap: wrap;
    }
    .team-page .panel-card :deep(.el-card__header) {
        padding: 12px 14px;
    }
    .team-page .panel-card :deep(.el-card__body) {
        padding: 12px;
    }
}
</style>

<!-- 弹窗会 teleport 到 body，样式需放在非 scoped 块并带唯一前缀 -->
<style>
.team-dialog {
    /* 主色令牌需在此再声明一遍，弹窗取不到页面作用域 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);
}
.team-dialog .el-dialog__header {
    margin-right: 0;
    padding: 22px 24px 0;
}
.team-dialog .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: #1f2d3d;
}
.team-dialog .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
}
.team-dialog .el-dialog__body {
    padding: 18px 24px 4px;
}
.team-dialog .el-dialog__footer {
    padding: 0 24px 22px;
}
.team-dialog .el-form-item {
    margin-bottom: 18px;
}
.team-dialog .el-form-item__label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: #8a94a6;
}
.team-dialog__foot {
    display: flex;
    gap: 10px;
}
.team-dialog__foot .el-button {
    flex: 1 1 0;
    height: 40px;
    margin-left: 0;
    border-radius: 10px;
}
.team-dialog .team-table {
    --el-table-header-bg-color: #f7f9fc;
    font-size: 13px;
}
.team-dialog .team-table th.el-table__cell {
    color: #8a94a6;
    font-weight: 600;
}
.team-dialog .team-table .el-table__cell {
    padding: 8px 0;
}
</style>
